import React from 'react';
import CandidateAvailabilityBooking from '../../Components/CandidateAvailabilityBooking/CandidateAvailabilityBooking';
import ConnectRepository from '../../Repositories/ConnectRepository';

// Nothing here comes from the store: the link resolves anonymously off its token.
const repository = new ConnectRepository();

const CandidateAvailabilityBookingContainer = () => <CandidateAvailabilityBooking repository={repository} />;

export default CandidateAvailabilityBookingContainer;
